angular.
module("dx.webapp.accessibility", []);
